module.exports = __webpack_public_path__ + "media/images/flags/4x3/kor-893263e73f879b8a853c8fb4023dcd98.svg";